module.exports = __webpack_public_path__ + "img/online-system.75385abe.jpg";